import { CarStatuses, LogisticsKRCar } from '../../types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ASharedModal from '../../../../components/SharedModal/ASharedModal'
import { AnalyticsPlaces } from '../../analyticsPlaces'
import { SharedModalContent, SharedModalTitle } from 'views/components/SharedModal'
import ADefaultModalFooter from '../../../../components/DefaultModalFooter/ADefaultModalFooter'
import { Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { refetchFunc } from 'modules/domain/common/hooks'
import { useNotification } from 'hooks/useNotification'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'

interface Props {
  car: LogisticsKRCar
  onClose: () => void
  onSuccess: refetchFunc
}

export const ToActiveConfirmModal: FC<Props> = ({ onClose, car, onSuccess }) => {
  const { t } = useTranslation('logisticsKR')
  const notify = useNotification()

  const [progress, changeStatusToActive] = useAProgress(
    (carId: string) => apiClient.post(endpoints.LogisticsKR.carStatus(carId), { new_status: CarStatuses.active }),
    {
      eventName: 'activeCar',
      onSuccess: () => {
        onSuccess(true)
        notify(Progress.SUCCESS, { title: t('carsEdit.notifications.car_active_success') })
        onClose()
      },
      onError: () => notify(Progress.ERROR, { title: t('carsEdit.notifications.car_active_error') }),
    },
  )

  return (
    <ASharedModal id={AnalyticsPlaces.CARRIERS.CHANGE_CAR_STATUS_MODAL} size="small" onClose={onClose}>
      <SharedModalTitle>{t('cars.confirmModals.statusChangingTitle')}</SharedModalTitle>
      <SharedModalContent>
        {car.ready_for_active
          ? t('cars.confirmModals.youReallyWantToChangeStatus')
          : t('cars.confirmModals.allFieldsMustBeFilledIn')}
      </SharedModalContent>
      <ADefaultModalFooter
        progress={progress}
        disabled={!car.ready_for_active}
        onConfirm={() => changeStatusToActive(car.id)}
        onClose={onClose}
      />
    </ASharedModal>
  )
}
